import { Component, computed } from '@angular/core';
import { compareAsc } from 'date-fns';
import { MDTagComponent } from '@melodic-ui/components';
import { NotificationBaseComponent } from './notification-base/notification-base.component';
import { ILesson } from '@lb/api/mylb/interfaces';

@Component({
	standalone: true,
	selector: 'lb-notification-accepted-additional',
	imports: [NotificationBaseComponent, MDTagComponent],
	template: ` <lb-notification-base [notification]="notification()">
		<div activity-message>Accepted your recommendation and scheduled <b>extra lessons.</b></div>
		<div activity-action>
			@if (lesson().makeUp) {
				<md-tag>Makeup Lesson</md-tag>
			}
		</div>
	</lb-notification-base>`,
	styleUrls: ['./notification-base-shared.component.scss']
})
export class NotificationEnrollmentExtraLessonsComponent extends NotificationBaseComponent {
	lesson = computed(() => this.notification().data as ILesson);

	originalDate = computed(() => {
		const sortedHistory = this.lesson().history.sort((a, b) => compareAsc(a.lessonHistoryCreateDate, b.lessonHistoryCreateDate));
		return sortedHistory[0].lessonDate;
	});
}
